import { render, staticRenderFns } from "./Grua.vue?vue&type=template&id=23d2c25a&scoped=true"
import script from "./Grua.vue?vue&type=script&lang=js"
export * from "./Grua.vue?vue&type=script&lang=js"
import style0 from "./Grua.vue?vue&type=style&index=0&id=23d2c25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2c25a",
  null
  
)

export default component.exports